import { render, staticRenderFns } from "./CSVRecordsConfiguration.vue?vue&type=template&id=c00904c8"
import script from "./CSVRecordsConfiguration.vue?vue&type=script&lang=js"
export * from "./CSVRecordsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./CSVRecordsConfiguration.vue?vue&type=style&index=0&id=c00904c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports